'use client';

import { SessionProvider } from 'next-auth/react';
import React from 'react';
import { Toaster } from 'react-hot-toast';
import DomRemoveChildTracer from './DomRemoveChildTracer';
import { ThemeProvider } from './ThemeProvider';
import { TooltipProvider } from './ui/tooltip';

const Providers = ({ children }: { children: React.ReactNode }) => {
  return (
    <SessionProvider refetchOnWindowFocus={false} refetchInterval={0}>
      <ThemeProvider>
        {process.env.NODE_ENV === 'development' ? <DomRemoveChildTracer /> : null}

        <TooltipProvider delayDuration={150} skipDelayDuration={0}>
          {children}
        </TooltipProvider>

        <Toaster />
      </ThemeProvider>
    </SessionProvider>
  );
};

export default Providers;
